/*
 * Marketing API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.26
 *
 * Do not edit the class manually.
 *
 */
import {ApiClient} from '../ApiClient';
import {AutomationdataSourceParams} from './AutomationdataSourceParams';
import {DataAutomationConnection} from './DataAutomationConnection';

/**
 * The DataAutomationDestination model module.
 * @module model/DataAutomationDestination
 * @version 1.0.0
 */
export class DataAutomationDestination {
  /**
   * Constructs a new <code>DataAutomationDestination</code>.
   * @alias module:model/DataAutomationDestination
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>DataAutomationDestination</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/DataAutomationDestination} obj Optional instance to populate.
   * @return {module:model/DataAutomationDestination} The populated <code>DataAutomationDestination</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new DataAutomationDestination();
      if (data.hasOwnProperty('connection'))
        obj.connection = DataAutomationConnection.constructFromObject(data['connection']);
      if (data.hasOwnProperty('params'))
        obj.params = ApiClient.convertToType(data['params'], [AutomationdataSourceParams]);
    }
    return obj;
  }
}

/**
 * @member {module:model/DataAutomationConnection} connection
 */
DataAutomationDestination.prototype.connection = undefined;

/**
 * @member {Array.<module:model/AutomationdataSourceParams>} params
 */
DataAutomationDestination.prototype.params = undefined;

